<template>
  <v-dialog :value="dialogProp.show" persistent max-width="900">
    <v-card class="elevation-12">
      <v-toolbar dense :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Подача оферты') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || innerLoading" class="my-0 py-0 mx-1">
        <v-col v-if="innerLoading" cols="12">
          <v-progress-linear :active="innerLoading" color="loader" indeterminate />
        </v-col>
        <v-col v-if="!!generalError" class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-alert
          class="text-center ma-1"
          outlined
          :value="success"
          type="success">
        {{ $t('Заявка успешно внесена') }}
      </v-alert>
      <v-card-text class="pt-8">
        <ValidationObserver ref="order">
          <v-row v-if="!!dialogProp.premiumStep || showDeliveryBasises" class="pt-3 mb-2">
            <v-col v-if="!!dialogProp.premiumStep" cols="12" :md="showZero? 7:3">
              <validatable-premium-step-selector
                  v-model="stepCount"
                  rules="required"
                  :label="premiumStepLabel"
                  :start-premium-label="startPremiumLabel"
                  :step="dialogProp.premiumStep"
                  :add-zero="showZero"
                  :readonly="showZero || isLoading || !order.premiums.length"
                  hide-details="auto"
                  dense
                  :max-step-count="MAX_PREMIUM_STEP_COUNT"
                  @change="changePremiumStep" />
            </v-col>
            <v-col v-if="showDeliveryBasises" cols="12" :md="showZero? 5:9">
              <validatable-combobox
                  v-model="order.deliveryBasisRevisionId"
                  item-value="deliveryBasisRevisionId"
                  item-text="description"
                  rules="required"
                  dense
                  hide-details="auto"
                  :items="dialogProp.deliveryBasises"
                  :label="$t('Порт/место назначения')"
                  @change="deliveryBasisChanged" />
            </v-col>
          </v-row>
          <v-row />
          <v-divider />
          <v-data-table
              :headers="headers"
              :items="order.premiums || []"
              :items-per-page="-1"
              item-key="positionId"
              disable-sort-by
              :locale="systemLocale"
              hide-default-footer
              dense>
            <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
            <template v-slot:item.positionDescription="{ item }">
              {{ item.positionDescription }}
            </template>
            <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
            <template v-slot:item.premiumWithDelivery="{ item }">
              <v-row class="pb-1 pt-0 my-0">
                <v-col class="py-0 my-0">
                  <validatable-text-input
                      :id="item.positionId"
                      v-model="item.premiumWithDelivery"
                      :vid="item.positionId"
                      :readonly="innerLoading || !!dialogProp.premiumStep"
                      :rules="{ required: true,
                                max_value: dialogProp.isFixPremium
                                  ? MAX_FIX_PREMIUM_VALUE
                                  : MAX_DIFF_PREMIUM_VALUE,
                                min_value: dialogProp.isFixPremium
                                  ? MIN_FIX_PREMIUM_VALUE
                                  : MIN_DIFF_PREMIUM_VALUE,
                                regex: dialogProp.isFixPremium
                                  ? /^[0-9]{1,11}([.][0-9]{0,2})?$/
                                  : /^([-])?[0-9]{1,3}([.][0-9]{0,2})?$/ }"
                      single-line
                      :label="premiumLabel"
                      hide-details="auto"
                      :tabindex="1"
                      solo
                      dense
                      data-type="float" />
                </v-col>
              </v-row>
            </template>
          </v-data-table>
          <v-divider />
          <v-row v-if="dialogProp.showAdditionalInfo" class="py-0 my-1">
            <v-col class="py-0 my-0">
              <validatable-textarea
                  v-model="order.additionalInfo"
                  :tabindex="3"
                  :readonly="isLoading"
                  :rules="{ max: 2000 }"
                  :label="$t('Дополнительные условия')" />
            </v-col>
          </v-row>
          <v-row v-if="dialogProp.showAdditionalInfo" align-content="center" class="mx-1 my-0 py-0">
            <text-view
                cols="2"
                :display="' '"
                :label="$t('Файл')" />
            <v-col
                v-if="file.fileId"
                cols="1"
                class="ma-0 pa-0"
                align-self="start">
              <btn-icon-tip
                  :disabled="isLoading"
                  icon="delete"
                  :tip="$t('Удалить документ')"
                  @click="deleteFile(file.fileId)" />
            </v-col>
            <v-col
                v-if="!file.fileId"
                cols="1"
                class="ma-0 pa-0">
              <typed-file-upload
                  :disabled="isLoading"
                  accept=".doc,.docx,.xls,.xlsx,.pdf"
                  :document-type="documentType"
                  :document-group="documentGroup"
                  :upload-method="uploadSingleBusinessFile" />
            </v-col>
            <v-col class="ma-0 pa-0" cols="9">
              <text-view
                  v-if="file.fileId"
                  :display="file.fileName" />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-left py-0">
              <validatable-checkbox
                  v-model="approve"
                  :readonly="innerLoading"
                  rules="required"
                  :label="conditionLabel" />
            </v-col>
          </v-row>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelConfirmBtn"
            color="primary"
            @click="cancel">
          {{ $t('Закрыть') }}
        </v-btn>
        <v-btn
            id="continueOperationBtn"
            color="primary"
            :disabled="!approve || innerLoading"
            @click.stop="openConfirmDialogOrSendRequest">
          {{ $t('Подать') }}
        </v-btn>
        <new-order-confirm-not-f-o-b-dialog
            v-if="newOrderConfirmDialog.show"
            :dialog-prop="newOrderConfirmDialog"
            @close="closeDialog('newOrderConfirmDialog')"
            @cancel="newOrderCanceled" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import TypedFileUpload from '@/components/reused/ui/TypedFileUpload.vue'
  import ValidatableCheckbox from '@/components/reused/ui/ValidatableCheckbox.vue'
  import ValidatableTextarea from '@/components/reused/ui/ValidatableTextarea.vue'
  import ValidatableCombobox from '@/components/reused/ui/ValidatableCombobox.vue'
  import ValidatablePremiumStepSelector from '@/components/reused/ui/ValidatablePremiumStepSelector.vue'
  import NewOrderConfirmNotFOBDialog from './NewOrderConfirmNotFOBDialog.vue'
  import { CURRENT_ORGANIZATION, CURRENT_USER, BUSINESS_FILES } from '@/constants/store'
  import {
    MAX_PREMIUM_STEP_COUNT, WARNING_PREMIUM_STEP_COUNT,
    MAX_FIX_PREMIUM_VALUE, MIN_FIX_PREMIUM_VALUE,
    MAX_DIFF_PREMIUM_VALUE, MIN_DIFF_PREMIUM_VALUE,
    DOCUMENT_TYPES, BUSINESS_DOCUMENT_GROUPS
  } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import lodash from 'lodash'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'

  export default {
    components: {
      GeneralError,
      ValidatableTextInput,
      TextView,
      BtnIconTip,
      ValidatableCheckbox,
      ValidatableTextarea,
      ValidatablePremiumStepSelector,
      NewOrderConfirmNotFOBDialog,
      TypedFileUpload,
      ValidatableCombobox
    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            isFixPremium: false,
            showAdditionalInfo: false,
            showZero: false,
            premiumStep: null,
            positions: null,
            currentDeliveryBasisId: null,
            deliveryBasises: null,
            callback: null,
            show: false
          }
        }
      }
    },
    data () {
      return {
        // разделено на два флага, чтобы контролировать обновление премий во время подачи запроса
        isLoading: false,
        isOrgLoading: false,
        success: false,
        approve: false,
        MAX_PREMIUM_STEP_COUNT,
        WARNING_PREMIUM_STEP_COUNT,
        MAX_FIX_PREMIUM_VALUE,
        MIN_FIX_PREMIUM_VALUE,
        MAX_DIFF_PREMIUM_VALUE,
        MIN_DIFF_PREMIUM_VALUE,
        documentType: DOCUMENT_TYPES.OFFER_ADDITIONAL_INFO,
        documentGroup: BUSINESS_DOCUMENT_GROUPS.OFFER_ADDITIONAL_INFO,
        stepCount: 0,
        order: {
          fileId: null,
          additionalInfo: null,
          deliveryBasisRevisionId: null,
          premiums: []
        },
        newOrderConfirmDialog: {
          show: false,
          stepCount: null,
          stepValue: null,
          premiums: [],
          deliveryBasisName: null,
          organizationName: null,
          callback: null
        },
        deliveryInfo: null
      }
    },
    computed: {
      ...mapState(CURRENT_ORGANIZATION.NAMESPACE, {
        organization: state => (state[CURRENT_ORGANIZATION.STATE.ORGANIZATION] || {})
      }),
      ...mapState(CURRENT_USER.NAMESPACE, {
        currentUser: state => (state || {})
      }),
      ...mapState(BUSINESS_FILES.NAMESPACE, {
        file: state => (state[BUSINESS_FILES.STATE.CURRENT_FILE] || {})
      }),
      headers () {
        const headers = [
          { text: this.$t('Наименование позиции'), align: 'start', sortable: false, value: 'positionDescription' },
          { text: this.premiumLabel, align: 'start', sortable: false, value: 'premiumWithDelivery' }
        ]

        return headers
      },
      conditionLabel () {
        return this.$t('Подтверждаем выбранный Порт/ место назначения. Признаем, что поданная {0} оферта в электронной форме является предложением {1}, ОГРН: {2}, содержащим всю необходимую информацию для заключения Контракта. Настоящая оферта является уведомлением о безусловном согласии на заключение Контракта на условиях, содержащихся в настоящей оферте, в случае ее акцепта Организатором.',
                       [this.currentUser.contactPerson,
                        this.organization.organizationShortName,
                        this.organization.ogrn])
      },
      premiumStepLabel () {
        return this.$t(this.dialogProp.isFixPremium
          ? 'Шаг цены'
          : 'Шаг дифференциала')
      },
      startPremiumLabel () {
        return this.$t(this.dialogProp.isFixPremium
          ? 'Начальная цены (без шага)'
          : 'Стартовое значение дифференциала (без шага)')
      },
      premiumLabel () {
        const premiumLabel = this.dialogProp.isFixPremium
          ? 'Значение цены в базисе поставки'
          : 'Значение дифференциала в базисе поставки'

        return this.$t(premiumLabel)
      },
      currentDeliveryBasises () {
        const vm = this
        return vm.order.deliveryBasisRevisionId
          ? this.dialogProp.deliveryBasises.find(db => db.deliveryBasisRevisionId === vm.order.deliveryBasisRevisionId)
          : null
      },
      showZero () {
        return !this.dialogProp.showZero || this.isLoading
      },
      showDeliveryBasises () {
        return this.dialogProp.deliveryBasises &&
          this.dialogProp.deliveryBasises.length
      },
      innerLoading () {
        return this.isOrgLoading || this.isLoading
      }
    },
    watch: {
      'dialogProp.positions': {
        // immediate: true,
        // deep: true,
        handler (newVal, oldVal) {
          // ограничено изменение новой цены во время отправки заявки
          if (!lodash.isEqual(newVal, oldVal) && !this.isLoading) {
            this.initPremiums(newVal, true)
          }
        }
      },
      showZero: {
        immediate: true,
        handler (newVal) {
          // ограничено изменение новой цены во время отправки заявки
          if (!newVal &&
            this.stepCount === 0 &&
            !this.isLoading) {
            this.stepCount = 1
          }
        }
      }
    },
    created () {
      if (!this.organization.organizationId) {
        this.getCurrentOrganization()
      }
      this.order.deliveryBasisRevisionId = this.dialogProp.currentDeliveryBasisId
      this.initPremiums(this.dialogProp.positions, true)
    },
    beforeDestroy () {
      this.clearSingleBusinessFileAction()
    },
    methods: {
      ...mapActions(CURRENT_ORGANIZATION.NAMESPACE, {
        getCurrentOrganizationAction: CURRENT_ORGANIZATION.ACTIONS.GET_CURRENT_ORGANIZATION
      }),
      ...mapActions(BUSINESS_FILES.NAMESPACE, {
        uploadSingleBusinessFileAction: BUSINESS_FILES.ACTIONS.UPLOAD_SINGLE_BUSINESS_FILE,
        deleteBusinessFileAction: BUSINESS_FILES.ACTIONS.DELETE_BUSINESS_FILE,
        clearSingleBusinessFileAction: BUSINESS_FILES.ACTIONS.CLEAR_SINGLE_BUSINESS_FILE
      }),
      uploadSingleBusinessFile: async function (form, documentType, documentGroup) {
        // try catch не нужен (если ошибка, обработаем в месте вызова метода)

        if (this.isAdmin) {
          form.append('creatorId', this.dialogProp.lot.creatorId)
        }
        try {
          this.isLoading = true
          await this.uploadSingleBusinessFileAction({
            form,
            documentType,
            documentGroup
          })
          this.order.fileId = this.file.fileId
        } finally {
          this.isLoading = false
        }
      },
      deleteFile: async function (fileId) {
        try {
          this.isLoading = true
          await this.deleteBusinessFileAction({ fileId })
          await this.clearSingleBusinessFileAction()
          this.order.fileId = null
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      initPremiums: function (nextPremiums, editStepCount) {
        const vm = this
        const key = this.order.deliveryBasisRevisionId?.toLowerCase()
        const next = key && nextPremiums ? nextPremiums[key] || [] : []
        if (next.length) {
          if (!vm.order.premiums.length) {
            vm.order.premiums = next.map(p => ({
              ...p
            }))
          } else {
            if (!vm.newOrderConfirmDialog.show) {
              vm.order.premiums = next.map(p => ({
                ...p
              }))
              if (editStepCount) {
                vm.stepCount = 1
              }
              vm.approve = false
            }
          }
        }
      },
      changePremiumStep: function (stepCount) {
        const vm = this
        var deltaStep = stepCount - vm.stepCount
        vm.order.premiums = vm.order.premiums.map(p => ({
          ...p,
          premiumWithDelivery: Number.parseFloat((p.premiumWithDelivery + (deltaStep * vm.dialogProp.premiumStep)).toFixed(2))
        }))
        vm.approve = false
      },
      newOrderCanceled: function () {
        this.initPremiums(this.dialogProp.positions, true)
      },
      deliveryBasisChanged: function (item) {
        this.newOrderConfirmDialog.deliveryBasisName = item?.description
        this.deliveryInfo = item
        this.initPremiums(this.dialogProp.positions, false)
        this.$emit('deliveryBasisChanged', item?.deliveryBasisRevisionId || null)
      },
      openConfirmDialogOrSendRequest: async function () {
        await this.hideErrorAction()
        try {
          const result = await this.$refs.order.validate()
          if (!result) {
            return
          }
          if (!this.order.premiums.length) {
            throw new Vue.errorsTypes.ValidationError(this.$t('Заявка сформирована некорректно. Обратитесь к администратору.'))
          }
          if (this.stepCount < 5) {
            this.isLoading = true
            await this.continueOperationThrowErrors()
          } else {
            this.openNewOrderConfirmDialog()
          }
        } catch (error) {
          this.throwIfUnknownError(error)
        } finally {
          this.isLoading = false
        }
      },
      getCurrentOrganization: async function () {
        this.isOrgLoading = true
        try {
          await this.getCurrentOrganizationAction()
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isOrgLoading = false
        }
      },
      openNewOrderConfirmDialog: function () {
        this.newOrderConfirmDialog.stepCount = this.stepCount
        this.newOrderConfirmDialog.stepValue = Number.parseFloat((this.stepCount * this.dialogProp.premiumStep).toFixed(2))
        this.newOrderConfirmDialog.premiums = this.order.premiums
        this.newOrderConfirmDialog.isFixPremium = this.dialogProp.isFixPremium
        this.newOrderConfirmDialog.organizationName = this.organization.organizationShortName
        this.newOrderConfirmDialog.callback = this.continueOperation
        this.newOrderConfirmDialog.show = true
      },
      continueOperation: async function () {
        try {
          this.isLoading = true
          await this.continueOperationThrowErrors()
        } catch (error) {
          this.throwIfUnknownError(error)
        } finally {
          this.isLoading = false
        }
      },
      continueOperationThrowErrors: async function () {
        this.success = false
        if (this.dialogProp.callback) {
          await this.dialogProp.callback({
            ...this.order,
            premiums: this.order.premiums.map(p => ({
              positionId: p.positionId,
              premium: 0,
              premiumWithDelivery: p.premiumWithDelivery
            }))
          })
        }
        this.success = true
        this.cancel()
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
